import { useCallback, useEffect, useRef } from "react";
import {
  findPendingTemplate,
  clearPendingTemplateId,
  REPORT_TEMPLATE_APPLY_EVENT,
} from "../utils/reportTemplatesStorage";

/**
 * @param {string} tab
 * @param {(fields: object) => void | Promise<void>} applyFn
 */
export function useApplyReportTemplate(tab, applyFn) {
  const applyRef = useRef(applyFn);
  applyRef.current = applyFn;
  const applyingRef = useRef(false);

  const tryApply = useCallback(() => {
    if (applyingRef.current) {
      return;
    }
    const tpl = findPendingTemplate();
    if (!tpl || tpl.tab !== tab) {
      return;
    }
    clearPendingTemplateId();
    applyingRef.current = true;
    void Promise.resolve(applyRef.current(tpl.fields)).finally(() => {
      applyingRef.current = false;
    });
  }, [tab]);

  useEffect(() => {
    tryApply();
  }, [tryApply]);

  useEffect(() => {
    const handler = () => tryApply();
    window.addEventListener(REPORT_TEMPLATE_APPLY_EVENT, handler);
    return () => window.removeEventListener(REPORT_TEMPLATE_APPLY_EVENT, handler);
  }, [tryApply]);
}
